import { TextBlock } from './TextBlock';
import { Button } from './Button';
import { SIZE_OPTIONS, SIZE_REFS_MAP } from '../../../constants/sizes';
import { QuizActionEvent } from '../../../constants/QuizActionEvent';
import { DecorBlock } from './DecorBlock';

export class TextBlockAndButtonPlusDecor extends TextBlock {
    _button3d;
    _decor3d;

    constructor(title, text, buttonLabel, clickAction, decorationKey = '') {
        super(title, text);

        const button3d = new Button(buttonLabel, clickAction);
        const decor3d = new DecorBlock(decorationKey);

        this.add(button3d);
        this.add(decor3d);

        this._button3d = button3d;
        this._decor3d = decor3d;
        this.hasInvalidate = this._decor3d.hasInvalidate;
    }

    _setup() {
        super._setup();
        this.waitForPreload = true;
        this.hasResize = true;
        this.hasStart = true;
        this.clickable = true;
    }

    invalidate(t, dt) {
        if (this._decor3d.hasInvalidate) this._decor3d.invalidate(t, dt);
    }

    resize(winWidth, winHeight, orientation, force, pixelRatio) {
        this._button3d.resize(winWidth, winHeight, orientation, force, pixelRatio);

        return super.resize(winWidth, winHeight, orientation, force, pixelRatio);
    }

    _resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio) {
        super._resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio);

        if (orientationChanged) {
            this._button3d.visible = orientation !== SIZE_OPTIONS.MOBILE_LANDSCAPE && orientation !== SIZE_OPTIONS.MOBILE_PORTRAIT;
        }
    }

    setupPreloadedContent(infrastructure) {
        if (this._button3d.waitForPreload) this._button3d.setupPreloadedContent(infrastructure);

        this._decor3d.construct();

        super.setupPreloadedContent(infrastructure);
    }

    _updateTextPosition(orientation) {
        super._updateTextPosition(orientation);

        const { buttonMarginTop } = SIZE_REFS_MAP[orientation];

        let y = this._text3d.position.y - this._text3d.textHeight * 0.5;

        y -= this._button3d.height * 0.5;
        y -= buttonMarginTop;

        this._button3d.position.y = y;

        this._decor3d.update(orientation);
    }

    // INTERACTION
    start() {
        if (!this.clickable) return;

        let handler = this._eventTransferHandler;

        if (!handler) {
            handler = (evt) => {
                this.dispatchEvent(evt);
            };

            this._eventTransferHandler = handler;
        }

        this._button3d.addEventListener(QuizActionEvent, handler);
        this._button3d.start();
    }

    stop() {
        if (!this.clickable) return;

        if (this._decor3d) this._decor3d.stop();

        if (this._eventTransferHandler) {
            this._button3d.removeEventListener(QuizActionEvent, this._eventTransferHandler);
            this._button3d.stop();
        }
    }

    set clickAction(val) {
        this._button3d.clickAction = val;
    }

    get clickAction() {
        return this._button3d.clickAction;
    }

    // Animation
    play() {
        if (this._decor3d) this._decor3d.play();
    }
}
